import { css } from 'styled-components';
import Colours from '/shared/styled/Colours';
import type { StyledHeaderTabsListItemProps } from '../types';

function isActiveStyle({ $isActive = false }: StyledHeaderTabsListItemProps) {
  if ($isActive) {
    return css<StyledHeaderTabsListItemProps>`
      > div:first-child {
        font-weight: 600;
      }

      > div:last-child {
        color: ${Colours.white};
      }
    `;
  }
}

function isVisibleStyle({ $isVisible = true }: StyledHeaderTabsListItemProps) {
  if (!$isVisible) {
    return css<StyledHeaderTabsListItemProps>`
      display: none;
    `;
  }
}

export default function dashboardListItemStyle({ $isDashboardListItemStyle = false }: StyledHeaderTabsListItemProps) {
  if ($isDashboardListItemStyle) {
    return css<StyledHeaderTabsListItemProps>`
      display: flex;
      max-width: 14rem;

      > * {
        display: flex;
        flex: 1;
        justify-content: space-between;

        > div:first-child {
          font-size: 1rem;
          font-weight: 400;
          margin: auto 0;
        }

        > div:last-child {
          min-height: 29px;
          text-align: center;
          font-weight: 600;
          background: ${Colours.green};
          border-radius: 100%;
          padding: ${({ hasThinPadding }) => (hasThinPadding ? '0.25rem' : '0.5rem')};
          aspect-ratio: 1/1;
          font-size: 1.25rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        ${isActiveStyle}
      }
      ${isVisibleStyle}
    `;
  }
}
